import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  text: {
    fontWeight: "400",
    fontSize: "1.5rem",
  }
}));

const Subtitle = ({ text }) => {
  const classes = useStyles();

  return (
    <Box mb={1}>
      <Typography variant="body1" component="p" color="textPrimary" className={classes.text}>
        {text}
      </Typography>
    </Box>
  );
};

export default Subtitle;